import Icon, { IconSizing } from 'components/Kizen/Icon';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid ${({ color }) => `${color}`};
`;

const CenteredIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;

  && {
    transform: translate(-50%, -50%) !important;
  }
`;

export default function TypeIcon({
  className = '',
  color = 'var(--color-background-darker)',
  icon = 'cycle-hamburger',
  size = 'intrinsic',
}) {
  return (
    <Wrapper color={color} className={className}>
      <IconSizing size={size}>
        <CenteredIcon color={color} icon={icon} />
      </IconSizing>
    </Wrapper>
  );
}
